
export default {
  setup() {
    const goBack = () => {
      window.location.href = '/shop';
    }
    return {
      goBack
    }
  }
}
